
import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import * as ExpertWebsocket from './expert.websocket';

export function* bookMeeting(action: any): SagaIterator {
  try {
    ExpertWebsocket.bookMeeting(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* bookChat(action: any): SagaIterator {
  try {
    ExpertWebsocket.bookChat(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 


// WEBPACK FOOTER //
// ./src/services/expert/expert.saga.ts